/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from "react";
import { NavLink, Link, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { authAction, profileAction } from "@redux/modules";
import { API } from "../../../../services/http.service";
import LegalText from "@components/LegalText";
import { LEGAL_TEXT_TYPES } from "../../../../constants/legalText.const";

//style
import style from './signUp.module.scss';

// Bootstrap
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import { Modal } from 'react-bootstrap';

// Input Mask
import InputMask from 'react-input-mask';

// Toastify
import showErrMessage from "@components/ShowErrMessage";
import showMessage from "@components/ShowMessage";

// Timer
import Timer from "@components/Timer";

// Form Validations
import { Formik } from 'formik';
import * as yup from 'yup';

/**
 * İşletme (USER2), "Arkadaş Tavsiyesi" ile geldiğinde başka bir işletmenin referans kodunu girer
 * ("Arkadaşını Getir").
 */
const isFriendReference = (userType, source) =>
  userType === "USER2" && source === "FRIEND_RECOMMENDATION";

/**
 * "İşletmeni Getir": işletme (USER2), kendisini kayıt eden bayi satış temsilcisinin (USER)
 * referans kodunu girer. Bu akışta puan kazanımı yoktur, yalnızca kayıt temsilciye bağlanır.
 */
const isSalesRepReference = (userType, source) =>
  userType === "USER2" && source === "SALES_REPRESENTATIVE";

/** Kayıt formunda referans kodu alanının açıldığı durumlar. */
const isReferenceCodeSource = (userType, source) =>
  isFriendReference(userType, source) || isSalesRepReference(userType, source);

  const SingUp = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loginSettings = useSelector((store) => store.auth.loginSettings);
  const registerVendorError = useSelector(
    (store) => store.auth.registerVendorError
  );

  const [confirmValidated, setConfirmValidated] = useState(false);
  const [sentCode, setSentCode] = useState(false);
  const [time, setTime] = useState(null);
  const [timerExpired, setTimerExpired] = useState(false);
  const [confirmMobileNo, setConfirmMobileNo] = useState("");
  const [confirmUsername, setConfirmUsername] = useState("");
  const [confirmCode, setConfirmCode] = useState("");
  const [roleList, setRoleList] = useState([]);
  const [showKisiselVerilerModal, setShowKisiselVerilerModal] = useState(false);
  const [showAydinlatmaModal, setShowAydinlatmaModal] = useState(false);
  const [showElektronikIletiModal, setShowElektronikIletiModal] = useState(false);

  const [referenceCodeStatus, setReferenceCodeStatus] = useState("idle");
  const [referenceCodeMessage, setReferenceCodeMessage] = useState("");

  // Usta (USER3) davet kodu canlı doğrulama durumu.
  const [inviteStatus, setInviteStatus] = useState("idle"); // idle | loading | valid | invalid
  const [inviteInfo, setInviteInfo] = useState(null); // { businessName, used, limit, remaining, message }

  const [showPassword, setShowPassword] = useState(false);
  const [showPasswordAgain, setShowPasswordAgain] = useState(false);

  // Üye Ol servisi uzun sürebildiği için buton loading durumu (çift gönderimi de engeller).
  const [isSubmitting, setIsSubmitting] = useState(false);

  const provinces = useSelector((store) => store.profile.provinceList);

  const schema = yup.object({
    name: yup
      .string()
      .required("Lütfen Adınızı Giriniz!")
      .matches(/^[a-zA-ZğüşıöçĞÜŞİÖÇ\s]+$/, "Ad sadece harflerden oluşmalıdır"),
    surname: yup
      .string()
      .required("Lütfen Soyadınızı Giriniz!")
      .matches(/^[a-zA-ZğüşıöçĞÜŞİÖÇ\s]+$/, "Soyad sadece harflerden oluşmalıdır"),
    mobileNo: yup.string().required("Lütfen Telefon Numaranızı Giriniz!"),
    city: yup.string().required("Lütfen İl Seçiniz!"),
    email: yup
      .string()
      .email("Lütfen Gerçek Bir E-Posta Adresi Giriniz!"),
    username: yup.string().required("Lütfen Kullanıcı Adı Giriniz!"),
    dealerSignName: yup.string().required("Üye Tabela Adınızı Giriniz!"),
    // Bayi (USER) ve İşletme (USER2) bu alanı doldurur; Usta (USER3) yerine davet kodu girer.
    salesDocumentNumber: yup.string().when("userType", {
      is: (val) => val === "USER" || val === "USER2",
      then: (s) => s.required("Lütfen No Bilgisini Giriniz!"),
      otherwise: (s) => s.notRequired(),
    }),
    inviteCode: yup.string().when("userType", {
      is: (val) => val === "USER3",
      then: (s) => s.required("Lütfen davet kodunu giriniz!"),
      otherwise: (s) => s.notRequired(),
    }),
    userType: yup
      .string()
      .required("Lütfen Üye Tipi Seçiniz!")
      .notOneOf(["0"], "Lütfen Üye Tipi Seçiniz!"),
    source: yup.string().when("userType", {
      is: (val) => val && val !== "USER" && val !== "0",
      then: (s) => s.required("Lütfen bizi nereden duyduğunuzu seçiniz!"),
      otherwise: (s) => s.notRequired(),
    }),
    // "İşletmeni Getir": Satış Temsilcisi seçildiyse temsilcinin referans kodu ZORUNLUDUR.
    // "Arkadaşını Getir" (Arkadaş Tavsiyesi) akışında kod opsiyoneldir.
    usedReferenceCode: yup.string().when(["userType", "source"], {
      is: (userType, source) =>
        userType === "USER2" && source === "SALES_REPRESENTATIVE",
      then: (s) =>
        s.required("Lütfen satış temsilcisinin referans kodunu giriniz!"),
      otherwise: (s) => s.notRequired(),
    }),
    certificateBase64: yup.string().when("userType", {
      is: (val) => val === "USER3",
      then: (s) => s.required("Lütfen sertifika belgenizi yükleyiniz!"),
      otherwise: (s) => s.notRequired(),
    }),
    password: yup.string().required("Lütfen Şifrenizi Giriniz!").matches(
      // Büyük/küçük harf, rakam ve en az bir özel karakter (boşluk hariç tüm özel karakterler).
      "^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=\\S+$).{8,}$",
      "Şifreniz 8 Karakter, Bir Büyük Harf, Bir Küçük Harf, Bir Rakam ve Bir Özel Karakter İçermelidir!"
    ),
    passwordAgain: yup
      .string()
      .required("Lütfen Şifre Tekrarı Giriniz!")
      .oneOf([yup.ref("password"), null], "Şifreler Eşleşmiyor!"),
    agreement: yup
      .bool()
      .required()
      .oneOf([true], "Sözleşmeleri kabul etmek zorundasınız!"),
    marketingConsent: yup
      .bool()
      .required()
      .oneOf(
        [true],
        "Ticari elektronik ileti onayı kayıt için zorunludur."
      ),
  });

  const handleConfirmCode = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;

    if (form.checkValidity() !== false) {
      dispatch(
        authAction.registerVendorConfirm(
          confirmCode,
          confirmMobileNo,
          confirmUsername
        )
      )
        .then((e) => {
          if (e.isHttpSuccess) {
            showMessage("Kayıt Başarıyla Oluşturuldu.");
            setSentCode(true);
            navigate("/login");
          }
        })
        .catch((err) => {
          if (err.isHttpError) {
            if (err.error?.response?.data?.message) {
              const errorMessage = err.error.response.data.message;
              showErrMessage(errorMessage);
            } else if (err.error?.response?.data?.errors?.[0]?.message) {
              const errorMessage = err.error.response.data.errors[0].message;
              showErrMessage(errorMessage);
            } else {
              showErrMessage("Bir hata oluştu");
            }

            if (err.error?.response?.data?.code === 1044) {
              setTimeout(() => {
                navigate("/login");
              }, 2500);
            }
          }
        });
    }
    setConfirmValidated(true);
  };

  const handleSubmitSignupForm = (values) => {
    if (isSubmitting) {
      return;
    }
    // Usta (USER3): davet kodu doğrulanmadan kayıt ilerlemez.
    if (values.userType === "USER3" && inviteStatus !== "valid") {
      showErrMessage(
        inviteInfo?.message ||
          "Lütfen geçerli bir davet kodu giriniz."
      );
      return;
    }
    // Referans kodu girildiyse, seçilen kaynağın beklediği türde ve geçerli olmalıdır
    // (Arkadaş Tavsiyesi -> işletme kodu, Satış Temsilcisi -> temsilci kodu).
    if (
      isReferenceCodeSource(values.userType, values.source) &&
      values.usedReferenceCode &&
      referenceCodeStatus !== "valid"
    ) {
      showErrMessage(
        isSalesRepReference(values.userType, values.source)
          ? "Lütfen geçerli bir satış temsilcisi referans kodu giriniz."
          : "Lütfen sizi davet eden işletmenin geçerli referans kodunu giriniz."
      );
      return;
    }
    const payload = { ...values };
    if (!payload.email || payload.email.trim() === "") {
      delete payload.email;
    }
    console.log(payload);
    setIsSubmitting(true);
    dispatch(authAction.registerVendor(payload))
      .then((e) => {
        if (e.isHttpSuccess) {
          setConfirmMobileNo(values.mobileNo);
          setConfirmUsername(values.username);

          const time = new Date();
          time.setSeconds(time.getSeconds() + 120);
          setTime(time);
          setSentCode(true);
        } else {
          if (e.error?.response?.data?.errors?.[0]?.message) {
            const errorMessage = e.error.response.data.errors[0].message;
            showErrMessage(errorMessage);
          } else {
            showErrMessage("Bir hata oluştu");
          }
        }
      })
      .catch((err) => {
        if (err.isHttpError) {
          if (err.error?.response?.data?.message) {
            const errorMessage = err.error.response.data.message;
            showErrMessage(errorMessage);
          } else if (err.error?.response?.data?.errors?.[0]?.message) {
            const errorMessage = err.error.response.data.errors[0].message;
            showErrMessage(errorMessage);
          } else {
            showErrMessage("Bir hata oluştu");
          }

          if (err.error?.response?.data?.code === 1044) {
            setTimeout(() => {
              navigate("/login");
            }, 2500);
          }
        }
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  // Usta sertifika belgesi: PDF veya resim, en fazla 5 MB. Base64 olarak forma yazılır.
  const CERTIFICATE_MAX_SIZE = 5 * 1024 * 1024;
  const CERTIFICATE_ACCEPTED_TYPES = [
    "application/pdf",
    "image/jpeg",
    "image/jpg",
    "image/png",
  ];

  const handleCertificateChange = (e, setFieldValue) => {
    const file = e.target.files && e.target.files[0];
    if (!file) {
      return;
    }

    if (!CERTIFICATE_ACCEPTED_TYPES.includes(file.type)) {
      showErrMessage("Lütfen PDF veya resim (JPG/PNG) formatında bir belge yükleyiniz.");
      e.target.value = "";
      return;
    }

    if (file.size > CERTIFICATE_MAX_SIZE) {
      showErrMessage("Belge boyutu en fazla 5 MB olabilir.");
      e.target.value = "";
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result || "";
      // "data:...;base64,XXXX" -> sadece base64 kısmı
      const base64 = String(result).split(",")[1] || "";
      setFieldValue("certificateBase64", base64);
      setFieldValue("certificateFileName", file.name);
      setFieldValue("certificateMimeType", file.type);
    };
    reader.onerror = () => {
      showErrMessage("Belge okunamadı. Lütfen tekrar deneyiniz.");
    };
    reader.readAsDataURL(file);
  };

  // Davet kodu girilince işletmeyi canlı doğrular (işletme adı + kontenjan önizlemesi).
  const handleInviteCodeBlur = async (e, setFieldValue) => {
    const code = (e.target.value || "").trim().toUpperCase();
    setFieldValue("inviteCode", code);
    if (!code) {
      setInviteStatus("idle");
      setInviteInfo(null);
      return;
    }
    setInviteStatus("loading");
    try {
      const res = await API.get(`/employee/public/invite/validate/${code}`);
      const info = res.data || {};
      setInviteInfo(info);
      setInviteStatus(info.valid ? "valid" : "invalid");
    } catch (err) {
      setInviteStatus("invalid");
      setInviteInfo({
        message:
          "Girdiğiniz davet kodu geçersiz veya süresi dolmuş. Lütfen işletme yetkilinizden yeni bir kod isteyin.",
      });
    }
  };

  /**
   * Girilen referans kodunu canlı doğrular. İki akış aynı kod havuzunu kullandığı için kod
   * sahibinin rolü de kontrol edilir:
   *   - Arkadaş Tavsiyesi -> kod bir işletmeye (USER2) AİT OLMALI (expectedRole),
   *   - Satış Temsilcisi  -> kod bir işletmeye AİT OLMAMALI (excludedRole).
   * Temsilci rolü tek bir role sabitlenmez: tenant kendi temsilci rollerini (USER,
   * CRGSALESREP, ...) açabildiği için beyaz liste her yeni rolde kaydı kırardı.
   */
  const handleReferenceCodeBlur = async (e, setFieldValue, isSalesRep) => {
    let code = e.target.value;
    if (!code || code.trim() === "") {
      setReferenceCodeStatus("idle");
      setReferenceCodeMessage("");
      return;
    }

    code = code.trim().toUpperCase();
    setFieldValue("usedReferenceCode", code);

    setReferenceCodeStatus("loading");
    try {
      const res = await API.get(
        `/employee/public/validate-reference-code/${code}${
          isSalesRep ? "?excludedRole=USER2" : "?expectedRole=USER2"
        }`
      );
      setReferenceCodeStatus("valid");
      setReferenceCodeMessage(res.data);
    } catch (err) {
      setReferenceCodeStatus("invalid");
      setReferenceCodeMessage(
        isSalesRep
          ? "Geçersiz referans kodu. Lütfen satış temsilcinizin kodunu kontrol ediniz (işletme kodu bu alanda geçerli değildir)."
          : "Bu kod bir işletmeye ait değil. Sizi davet eden işletmenin referans kodunu giriniz."
      );
    }
  };

  useEffect(() => {
    if (timerExpired === true) {
      showErrMessage(
        "Süreniz doldu! Lütfen, Tekrar Kod Gönder butonuna basarak kod isteyiniz!"
      );
    }

    dispatch(profileAction.getAddressProvince(1));

    // Diğer sayfalardaki gibi dispatch kullanarak action üzerinden veriyi çekiyoruz
    dispatch(authAction.getRoleList())
      .then((res) => {
        if (res && res.data) {
          setRoleList(res.data);
        }
      })
      .catch((err) => {
        console.error("Rol listesi yüklenirken hata oluştu:", err);
      });

    return () => {};
  }, [timerExpired, dispatch]);

  // Süre dolduğunda kullanıcıyı giriş ekranına yönlendirmiyoruz; üyelik bilgileri korunur ve
  // "Tekrar Kod Gönder" butonu ile yeni kod istenebilir.
  const handleExpire = (expired) => {
    setTimerExpired(expired);
  };

  // Onay ekranında telefon numarasını maskeli gösterir: 0532 *** ** 67
  const maskPhone = (phone) => {
    if (!phone) return "";
    const digits = String(phone).replace(/\D/g, "");
    if (digits.length < 6) return digits;
    return `${digits.slice(0, 4)} *** ** ${digits.slice(-2)}`;
  };

  // Süre dolduğunda yeni onay kodu ister; sayacı sıfırlar ve onay alanını yeniden aktif eder.
  const handleResendCode = () => {
    dispatch(authAction.registerVendorResendCode(confirmMobileNo))
      .then((e) => {
        if (e.isHttpSuccess) {
          showMessage("Yeni onay kodu telefon numaranıza gönderildi.");
          const newTime = new Date();
          newTime.setSeconds(newTime.getSeconds() + 120);
          setTime(newTime);
          setTimerExpired(false);
          setConfirmCode("");
          setConfirmValidated(false);
        } else {
          showErrMessage("Kod gönderilemedi, lütfen tekrar deneyiniz.");
        }
      })
      .catch(() => {
        showErrMessage("Kod gönderilemedi, lütfen tekrar deneyiniz.");
      });
  };

  return (
    <React.Fragment>
      <section className="bg-gray-lightest min-vh-100">
        <Formik
          validationSchema={schema}
          onSubmit={(values) => handleSubmitSignupForm(values)}
          initialValues={{
            name: "",
            surname: "",
            mobileNo: "",
            city: "",
            email: "",
            username: "",
            dealerSignName: "",
            salesDocumentNumber: "",
            userType: "",
            password: "",
            passwordAgain: "",
            agreement: false,
            marketingConsent: false,
            tenantName: "tenant1",
            source: "",
            usedReferenceCode: "",
            certificateBase64: "",
            certificateFileName: "",
            certificateMimeType: "",
            inviteCode: "",
          }}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            setFieldValue,
            setFieldTouched,
          }) => (
            <Form
              noValidate
              onSubmit={handleSubmit}
              className={sentCode ? "d-none" : "d-flex"}
            >
              <div className="container">
                <div className="row justify-content-center pt-5">
                  <div className="col-xl-8 col-lg-8 col-md-12 col-10">
                    <div className="text-center mb-3">
                      <NavLink to="/login" className="d-inline-block">
                        {loginSettings?.logo && (
                          <img
                            src={loginSettings?.logo}
                            alt="logo"
                            className="auth-logo"
                          />
                        )}
                      </NavLink>
                    </div>
                    <h5 className="lh-base text-center fw-normal mb-3">
                      Lütfen üye olmak için gerekli alanları doldurunuz.
                    </h5>
                  </div>
                  <div className="w-100"></div>

                  {/* Section: Kişisel Bilgiler */}
                  <div className="col-xl-8 col-lg-8 col-md-12 col-10 mt-2 mb-1">
                    <div className="d-flex align-items-center">
                      <span
                        className="text-uppercase fw-semibold"
                        style={{ fontSize: 11, letterSpacing: 0.7, color: "#000" }}
                      >
                        Kişisel Bilgiler
                      </span>
                      <hr className="flex-grow-1 ms-3 my-0 opacity-25" />
                    </div>
                  </div>
                  <div className="w-100"></div>

                  <div className="col-xl-4 col-lg-4 col-md-6 col-10 mb-3">
                    <Form.Label
                      className="d-block small fw-medium mb-1 px-1"
                      style={{ fontSize: 12, color: "#000" }}
                    >
                      Üye Adı <span style={{ color: "#C62828" }}>*</span>
                    </Form.Label>
                    <div className="form-floating shadow-lg rounded-3">
                      <Form.Group controlId="validationCustom01">
                        <Form.Control
                          type="text"
                          className="form-control border-0 rounded-3 px-4"
                          placeholder="Adınız"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="name"
                          value={values.name}
                          isInvalid={
                            !!errors.name && touched.name && !!errors.name
                          }
                        />
                      </Form.Group>
                    </div>
                    <span className={style.errorMessage}>
                      {errors.name && touched.name && errors.name}
                    </span>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-6 col-10 mb-3">
                    <Form.Label
                      className="d-block small fw-medium mb-1 px-1"
                      style={{ fontSize: 12, color: "#000" }}
                    >
                      Üye Soyadı <span style={{ color: "#C62828" }}>*</span>
                    </Form.Label>
                    <div className="form-floating shadow-lg rounded-3">
                      <Form.Group controlId="validationCustom02">
                        <Form.Control
                          className="form-control border-0 rounded-3 px-4"
                          type="text"
                          placeholder="Soyadınız"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="surname"
                          value={values.surname}
                          isInvalid={
                            !!errors.surname &&
                            touched.surname &&
                            !!errors.surname
                          }
                        />
                      </Form.Group>
                    </div>
                    <span className={style.errorMessage}>
                      {errors.surname && touched.surname && errors.surname}
                    </span>
                  </div>
                  <div className="w-100"></div>

                  {/* Section: İletişim ve Erişim */}
                  <div className="col-xl-8 col-lg-8 col-md-12 col-10 mt-2 mb-1">
                    <div className="d-flex align-items-center">
                      <span
                        className="text-uppercase fw-semibold"
                        style={{ fontSize: 11, letterSpacing: 0.7, color: "#000" }}
                      >
                        İletişim ve Erişim
                      </span>
                      <hr className="flex-grow-1 ms-3 my-0 opacity-25" />
                    </div>
                  </div>
                  <div className="w-100"></div>

                  <div className="col-xl-4 col-lg-4 col-md-6 col-10 mb-3">
                    <Form.Label
                      className="d-block small fw-medium mb-1 px-1"
                      style={{ fontSize: 12, color: "#000" }}
                    >
                      Telefon <span style={{ color: "#C62828" }}>*</span>
                    </Form.Label>
                    <div className="form-floating shadow-lg rounded-3">
                      <Form.Group controlId="validationCustom03">
                        <InputMask
                          mask="05(99) 999 99 99"
                          maskChar="_"
                          value={values.mobileNo}
                          onChange={(e) => {
                            const digits = e.target.value.replace(/\D/g, "");
                            setFieldValue("mobileNo", digits);
                          }}
                          onBlur={handleBlur}
                        >
                          {(inputProps) => (
                            <Form.Control
                              {...inputProps}
                              type="text"
                              className="form-control border-0 rounded-3 px-4"
                              placeholder="05(__) ___ __ __"
                              name="mobileNo"
                              inputMode="numeric"
                              isInvalid={
                                !!errors.mobileNo &&
                                touched.mobileNo &&
                                !!errors.mobileNo
                              }
                            />
                          )}
                        </InputMask>
                      </Form.Group>
                    </div>
                    <small
                      className="text-muted px-1 d-block mt-1"
                      style={{ fontSize: 10 }}
                    >
                      Giriş için telefon numaranız da kullanılabilir
                    </small>
                    <span className={style.errorMessage}>
                      {errors.mobileNo && touched.mobileNo && errors.mobileNo}
                    </span>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-6 col-10 mb-3">
                    <Form.Label
                      className="d-block small fw-medium mb-1 px-1"
                      style={{ fontSize: 12, color: "#000" }}
                    >
                      Email{" "}
                      {/*<span style={{ color: "#94a3b8", fontWeight: 400, fontSize: 11 }}>(opsiyonel)</span>*/}
                    </Form.Label>
                    <div className="form-floating shadow-lg rounded-3">
                      <Form.Group controlId="validationCustom04">
                        <Form.Control
                          type="email"
                          className="form-control border-0 rounded-3 px-4"
                          placeholder="ornek@mail.com"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="email"
                          value={values.email}
                          isInvalid={
                            !!errors.email && touched.email && !!errors.email
                          }
                        />
                      </Form.Group>
                    </div>
                    <span className={style.errorMessage}>
                      {errors.email && touched.email && errors.email}
                    </span>
                  </div>
                  <div className="w-100"></div>

                  <div className="col-xl-8 col-lg-8 col-md-12 col-10 mb-3">
                    <Form.Label
                      className="d-block small fw-medium mb-1 px-1"
                      style={{ fontSize: 12, color: "#000" }}
                    >
                      Kullanıcı Adı <span style={{ color: "#C62828" }}>*</span>
                    </Form.Label>
                    <div className="form-floating shadow-lg rounded-3">
                      <Form.Group controlId="validationCustom05">
                        <Form.Control
                          className="form-control border-0 rounded-3 px-4"
                          autoComplete="chrome-off"
                          type="text"
                          placeholder="Kullanıcı adınızı belirleyin"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="username"
                          value={values.username}
                          isInvalid={
                            !!errors.username &&
                            touched.username &&
                            !!errors.username
                          }
                        />
                      </Form.Group>
                    </div>
                    <span className={style.errorMessage}>
                      {errors.username && touched.username && errors.username}
                    </span>
                  </div>
                  <div className="w-100"></div>

                  <div className="col-xl-4 col-lg-4 col-md-6 col-10 mb-3">
                    <Form.Label
                      className="d-block small fw-medium mb-1 px-1"
                      style={{ fontSize: 12, color: "#000" }}
                    >
                      Şifre <span style={{ color: "#C62828" }}>*</span>
                    </Form.Label>
                    <div className="form-floating shadow-lg rounded-3 position-relative">
                      <Form.Group controlId="validationCustom09">
                        <Form.Control
                          autoComplete="chrome-off"
                          className="form-control border-0 rounded-3 px-4 pe-5"
                          type={showPassword ? "text" : "password"}
                          placeholder="Min. 8 karakter"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="password"
                          value={values.password}
                          isInvalid={
                            !!errors.password &&
                            touched.password &&
                            !!errors.password
                          }
                        />
                        <button
                          type="button"
                          className="btn border-0 bg-transparent p-0 position-absolute"
                          style={{
                            right: "28px",
                            top: "calc(50% + 1px)",
                            transform: "translateY(-50%)",
                            zIndex: 5,
                            color: "#6c757d",
                          }}
                          onClick={() => setShowPassword((prev) => !prev)}
                          tabIndex={-1}
                          aria-label={showPassword ? "Şifreyi gizle" : "Şifreyi göster"}
                        >
                          <i
                            className={
                              showPassword ? "fas fa-eye-slash" : "fas fa-eye"
                            }
                          ></i>
                        </button>
                      </Form.Group>
                    </div>
                    <span className={style.errorMessage}>
                      {errors.password && touched.password && errors.password}
                    </span>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-6 col-10 mb-3">
                    <Form.Label
                      className="d-block small fw-medium mb-1 px-1"
                      style={{ fontSize: 12, color: "#000" }}
                    >
                      Şifre Tekrar <span style={{ color: "#C62828" }}>*</span>
                    </Form.Label>
                    <div className="form-floating shadow-lg rounded-3 position-relative">
                      <Form.Group controlId="validationCustom10">
                        <Form.Control
                          autoComplete="chrome-off"
                          className="form-control border-0 rounded-3 px-4 pe-5"
                          type={showPasswordAgain ? "text" : "password"}
                          placeholder="Şifrenizi tekrar girin"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="passwordAgain"
                          value={values.passwordAgain}
                          isInvalid={
                            !!errors.passwordAgain &&
                            touched.passwordAgain &&
                            !!errors.passwordAgain
                          }
                        />
                        <button
                          type="button"
                          className="btn border-0 bg-transparent p-0 position-absolute"
                          style={{
                            right: "28px",
                            top: "calc(50% + 1px)",
                            transform: "translateY(-50%)",
                            zIndex: 5,
                            color: "#6c757d",
                          }}
                          onClick={() => setShowPasswordAgain((prev) => !prev)}
                          tabIndex={-1}
                          aria-label={
                            showPasswordAgain ? "Şifreyi gizle" : "Şifreyi göster"
                          }
                        >
                          <i
                            className={
                              showPasswordAgain
                                ? "fas fa-eye-slash"
                                : "fas fa-eye"
                            }
                          ></i>
                        </button>
                      </Form.Group>
                    </div>
                    <span className={style.errorMessage}>
                      {errors.passwordAgain &&
                        touched.passwordAgain &&
                        errors.passwordAgain}
                    </span>
                  </div>
                  <div className="w-100"></div>

                  {/* Section: Firma Bilgileri */}
                  <div className="col-xl-8 col-lg-8 col-md-12 col-10 mt-2 mb-1">
                    <div className="d-flex align-items-center">
                      <span
                        className="text-uppercase fw-semibold"
                        style={{ fontSize: 11, letterSpacing: 0.7, color: "#000" }}
                      >
                        Firma Bilgileri
                      </span>
                      <hr className="flex-grow-1 ms-3 my-0 opacity-25" />
                    </div>
                  </div>
                  <div className="w-100"></div>

                  <div className="col-xl-4 col-lg-4 col-md-6 col-10 mb-3">
                    <Form.Label
                      className="d-block small fw-medium mb-1 px-1"
                      style={{ fontSize: 12, color: "#000" }}
                    >
                      İl Seçiniz <span style={{ color: "#C62828" }}>*</span>
                    </Form.Label>
                    <div className="form-floating shadow-lg rounded-3">
                      <Form.Group controlId="validationCustomCity">
                        <Form.Control
                          as="select"
                          className="form-select border-0 rounded-3 px-4"
                          onChange={(e) => {
                            handleChange(e);
                            console.log("Seçilen il:", e.target.value);
                          }}
                          onBlur={handleBlur}
                          name="city"
                          value={values.city}
                          isInvalid={
                            !!errors.city && touched.city && !!errors.city
                          }
                        >
                          <option value="">İl Seçiniz</option>
                          {provinces &&
                            provinces.map((item) => (
                              <option key={item.name} value={item.id}>
                                {item.name}
                              </option>
                            ))}
                        </Form.Control>
                      </Form.Group>
                    </div>
                    <span className={style.errorMessage}>
                      {errors.city && touched.city && errors.city}
                    </span>
                  </div>
                  <div className="col-xl-4 col-lg-4 col-md-6 col-10 mb-3">
                    <Form.Label
                      className="d-block small fw-medium mb-1 px-1"
                      style={{ fontSize: 12, color: "#000" }}
                    >
                      Üye Tabela Adı <span style={{ color: "#C62828" }}>*</span>
                    </Form.Label>
                    <div className="form-floating shadow-lg rounded-3">
                      <Form.Group controlId="validationCustom06">
                        <Form.Control
                          autoComplete="chrome-off"
                          className="form-control border-0 rounded-3 px-4"
                          type="text"
                          placeholder="Örn: Lezzet Dünyası Restoran"
                          onChange={handleChange}
                          onBlur={handleBlur}
                          name="dealerSignName"
                          value={values.dealerSignName}
                          isInvalid={
                            !!errors.dealerSignName &&
                            touched.dealerSignName &&
                            !!errors.dealerSignName
                          }
                        />
                      </Form.Group>
                    </div>
                    <small
                      className="text-muted px-1 d-block mt-1"
                      style={{ fontSize: 10 }}
                    >
                      Portalde görünecek isim
                    </small>
                    <span className={style.errorMessage}>
                      {errors.dealerSignName &&
                        touched.dealerSignName &&
                        errors.dealerSignName}
                    </span>
                  </div>
                  <div className="w-100"></div>

                  {/* Section: Üye Tipi Seçiniz */}
                  <div className="col-xl-8 col-lg-8 col-md-12 col-10 mt-2 mb-1">
                    <div className="d-flex align-items-center">
                      <span
                        className="text-uppercase fw-semibold"
                        style={{ fontSize: 11, letterSpacing: 0.7, color: "#000" }}
                      >
                        Üye Tipi Seçiniz
                      </span>
                      <hr className="flex-grow-1 ms-3 my-0 opacity-25" />
                    </div>
                  </div>
                  <div className="w-100"></div>

                  <div className="col-xl-8 col-lg-8 col-md-12 col-10 mb-3">
                    <Form.Label
                      className="d-block small fw-medium mb-1 px-1"
                      style={{ fontSize: 12, color: "#000" }}
                    >
                      Üye Tipi Seçiniz{" "}
                      <span style={{ color: "#C62828" }}>*</span>
                    </Form.Label>
                    <div className="form-floating shadow-lg rounded-3">
                      <Form.Group controlId="validationCustom08">
                        <Form.Control
                          as="select"
                          className="form-select border-0 rounded-3 px-4"
                          onChange={(e) => {
                            handleChange(e);
                            // BST seçildiğinde source ve referans kodu sıfırla
                            if (e.target.value === "USER") {
                              setFieldValue("source", "");
                              setFieldValue("usedReferenceCode", "");
                              setFieldTouched("usedReferenceCode", false);
                              setReferenceCodeStatus("idle");
                              setReferenceCodeMessage("");
                            }
                            // İşletme (USER2) dışı bir rol seçildiyse ve
                            // daha önce Arkadaş Tavsiyesi seçilmişse temizle
                            if (e.target.value !== "USER2") {
                              setFieldValue("usedReferenceCode", "");
                              setFieldTouched("usedReferenceCode", false);
                              setReferenceCodeStatus("idle");
                              setReferenceCodeMessage("");
                              if (values.source === "FRIEND_RECOMMENDATION") {
                                setFieldValue("source", "");
                              }
                            }
                            // Usta (USER3) dışına geçilince davet kodu durumunu sıfırla.
                            if (e.target.value !== "USER3") {
                              setFieldValue("inviteCode", "");
                              setInviteStatus("idle");
                              setInviteInfo(null);
                            }
                          }}
                          onBlur={handleBlur}
                          name="userType"
                          value={values.userType}
                          isInvalid={
                            !!errors.userType &&
                            touched.userType &&
                            !!errors.userType
                          }
                        >
                          <option value="0">Üye Tipi Seçiniz</option>
                          {roleList &&
                            roleList.map((item) => (
                              <option key={item.id} value={item.name}>
                                {item.description}
                              </option>
                            ))}
                        </Form.Control>
                      </Form.Group>
                    </div>
                    <span className={style.errorMessage}>
                      {errors.userType && touched.userType && errors.userType}
                    </span>
                  </div>
                  <div className="w-100"></div>

                  {values.userType &&
                    values.userType !== "0" &&
                    values.userType !== "USER3" && (
                      <>
                        <div className="col-xl-8 col-lg-8 col-md-12 col-10 mb-3">
                          <Form.Label
                            className="d-block small fw-medium mb-1 px-1"
                            style={{ fontSize: 12, color: "#000" }}
                          >
                            {values.userType === "USER"
                              ? "Bayi Kodu"
                              : "İşletme Vergi No"}{" "}
                            <span style={{ color: "#C62828" }}>*</span>
                          </Form.Label>
                          <div className="form-floating shadow-lg rounded-3">
                            <Form.Group controlId="validationCustom07">
                              <Form.Control
                                autoComplete="chrome-off"
                                className="form-control border-0 rounded-3 px-4"
                                type="text"
                                maxLength={11}
                                placeholder={
                                  values.userType === "USER"
                                    ? "Bayi kodunuzu giriniz"
                                    : "Vergi numaranızı giriniz"
                                }
                                onChange={handleChange}
                                onBlur={handleBlur}
                                name="salesDocumentNumber"
                                value={values.salesDocumentNumber}
                                isInvalid={
                                  !!errors.salesDocumentNumber &&
                                  touched.salesDocumentNumber &&
                                  !!errors.salesDocumentNumber
                                }
                              />
                            </Form.Group>
                          </div>
                          <span className={style.errorMessage}>
                            {errors.salesDocumentNumber &&
                              touched.salesDocumentNumber &&
                              errors.salesDocumentNumber}
                          </span>
                        </div>
                        <div className="w-100"></div>
                      </>
                    )}

                  {/* Usta (USER3): VKN yerine işletmeden alınan davet kodu */}
                  {values.userType === "USER3" && (
                    <>
                      <div className="col-xl-8 col-lg-8 col-md-12 col-10 mb-3">
                        <Form.Label
                          className="d-block small fw-medium mb-1 px-1"
                          style={{ fontSize: 12, color: "#000" }}
                        >
                          Davet Kodu{" "}
                          <span style={{ color: "#C62828" }}>*</span>
                        </Form.Label>
                        <div className="form-floating shadow-lg rounded-3">
                          <Form.Group controlId="validationInviteCode">
                            <Form.Control
                              autoComplete="off"
                              className="form-control border-0 rounded-3 px-4"
                              type="text"
                              placeholder="Örn. GURME-A7K2"
                              style={{ textTransform: "uppercase" }}
                              onChange={handleChange}
                              onBlur={(e) => {
                                handleBlur(e);
                                handleInviteCodeBlur(e, setFieldValue);
                              }}
                              name="inviteCode"
                              value={values.inviteCode}
                              isInvalid={
                                (!!errors.inviteCode &&
                                  touched.inviteCode) ||
                                inviteStatus === "invalid"
                              }
                            />
                          </Form.Group>
                        </div>
                        <small
                          className="text-muted px-1 d-block mt-1"
                          style={{ fontSize: 10 }}
                        >
                          Kodu işletme yetkilinizden alabilirsiniz
                        </small>

                        {inviteStatus === "loading" && (
                          <span
                            className="small mt-1 d-block px-1 text-muted"
                            style={{ fontSize: 11 }}
                          >
                            İşletme kontrol ediliyor...
                          </span>
                        )}

                        {inviteStatus === "valid" && inviteInfo && (
                          <div
                            className="mt-2 p-2 rounded"
                            style={{
                              background: "#EFF6FF",
                              borderLeft: "3px solid #3B82F6",
                            }}
                          >
                            <div
                              className="d-flex justify-content-between"
                              style={{ fontSize: 12 }}
                            >
                              <span style={{ color: "#1D4ED8", fontWeight: 600 }}>
                                {inviteInfo.businessName}
                              </span>
                              <span style={{ color: "#059669" }}>
                                {inviteInfo.used} / {inviteInfo.limit}
                              </span>
                            </div>
                            <div
                              className="mt-1"
                              style={{ fontSize: 10, color: "#64748B" }}
                            >
                              {inviteInfo.remaining} kontenjan kaldı
                            </div>
                          </div>
                        )}

                        {inviteStatus === "invalid" && (
                          <span
                            className={style.errorMessage}
                            style={{ display: "block" }}
                          >
                            {inviteInfo?.message ||
                              "Davet kodu geçersiz veya süresi dolmuş."}
                          </span>
                        )}

                        <span className={style.errorMessage}>
                          {errors.inviteCode &&
                            touched.inviteCode &&
                            errors.inviteCode}
                        </span>
                      </div>
                      <div className="w-100"></div>
                    </>
                  )}

                  {/* Bizi Nereden Duydunuz? - sadece Usta ve İşletme için (BST'de gizli) */}
                  {values.userType &&
                    values.userType !== "0" &&
                    values.userType !== "USER" && (
                      <>
                        <div className="col-xl-8 col-lg-8 col-md-12 col-10 mt-2 mb-1">
                          <div className="d-flex align-items-center">
                            <span
                              className="text-uppercase fw-semibold"
                              style={{ fontSize: 11, letterSpacing: 0.7, color: "#000" }}
                            >
                              Bizi Nereden Duydunuz?{" "}
                              <span style={{ color: "#C62828" }}>*</span>
                            </span>
                            <hr className="flex-grow-1 ms-3 my-0 opacity-25" />
                          </div>
                        </div>
                        <div className="w-100"></div>

                        <div className="col-xl-4 col-lg-4 col-md-6 col-10 mb-3">
                          <Form.Label
                            className="d-block small fw-medium mb-1 px-1"
                            style={{ fontSize: 12, color: "#000" }}
                          >
                            Seçiniz <span style={{ color: "#C62828" }}>*</span>
                          </Form.Label>
                          <div className="form-floating shadow-lg rounded-3">
                            <Form.Group controlId="validationSource">
                              <Form.Control
                                as="select"
                                className="form-select border-0 rounded-3 px-4"
                                onChange={(e) => {
                                  handleChange(e);
                                  // Kaynak değişti: girilmiş referans kodu her durumda silinir.
                                  // Arkadaş Tavsiyesi ile Satış Temsilcisi farklı yapılardır ve
                                  // farklı role ait kod bekler; önceki kod/doğrulama taşınmamalıdır.
                                  setFieldValue("usedReferenceCode", "");
                                  setFieldTouched("usedReferenceCode", false);
                                  setReferenceCodeStatus("idle");
                                  setReferenceCodeMessage("");
                                }}
                                onBlur={handleBlur}
                                name="source"
                                value={values.source}
                                isInvalid={
                                  !!errors.source &&
                                  touched.source &&
                                  !!errors.source
                                }
                              >
                                <option value="">Bizi Nereden Duydunuz?</option>
                                <option value="SALES_REPRESENTATIVE">
                                  Satış Temsilcisi
                                </option>
                                {values.userType === "USER2" && (
                                  <option value="FRIEND_RECOMMENDATION">
                                    Arkadaş Tavsiyesi
                                  </option>
                                )}
                                <option value="GOOGLE">Google</option>
                                <option value="INSTAGRAM">Instagram</option>
                                <option value="OTHER">Diğer</option>
                              </Form.Control>
                            </Form.Group>
                          </div>
                          <span className={style.errorMessage}>
                            {errors.source && touched.source && errors.source}
                          </span>
                        </div>

                        {!isReferenceCodeSource(values.userType, values.source) &&
                          values.userType === "USER3" && (
                            <div className="col-xl-4 col-lg-4 col-md-6 col-10 mb-3">
                              <Form.Label
                                className="d-block small fw-medium mb-1 px-1"
                                style={{ fontSize: 12, color: "#000" }}
                              >
                                Sertifika Belgesi{" "}
                                <span style={{ color: "#C62828" }}>*</span>
                              </Form.Label>
                              <div className="form-floating shadow-lg rounded-3">
                                <Form.Group controlId="validationCertificate">
                                  <Form.Control
                                    type="file"
                                    accept="application/pdf,image/jpeg,image/png"
                                    className="form-control border-0 rounded-3 px-4 py-2"
                                    onChange={(e) =>
                                      handleCertificateChange(e, setFieldValue)
                                    }
                                    onBlur={handleBlur}
                                    name="certificateBase64"
                                    isInvalid={
                                      !!errors.certificateBase64 &&
                                      touched.certificateBase64 &&
                                      !!errors.certificateBase64
                                    }
                                  />
                                </Form.Group>
                              </div>
                              <small
                                className="text-muted px-1 d-block mt-1"
                                style={{ fontSize: 10 }}
                              >
                                PDF veya resim (JPG/PNG), en fazla 5 MB
                                {values.certificateFileName
                                  ? ` — ${values.certificateFileName}`
                                  : ""}
                              </small>
                              <span className={style.errorMessage}>
                                {errors.certificateBase64 &&
                                  touched.certificateBase64 &&
                                  errors.certificateBase64}
                              </span>
                            </div>
                          )}

                        {!isReferenceCodeSource(values.userType, values.source) &&
                          values.userType !== "USER3" && (
                            <div
                              className="col-xl-4 col-lg-4 col-md-6 d-none d-md-block"
                              aria-hidden="true"
                            />
                          )}

                        {isReferenceCodeSource(
                          values.userType,
                          values.source
                        ) && (
                          <div className="col-xl-4 col-lg-4 col-md-6 col-10 mb-3">
                            <Form.Label
                              className="d-block small fw-medium mb-1 px-1"
                              style={{ fontSize: 12, color: "#000" }}
                            >
                              {isSalesRepReference(values.userType, values.source) ? (
                                <>
                                  Satış Temsilcisi Referans Kodu{" "}
                                  <span style={{ color: "#C62828" }}>*</span>
                                </>
                              ) : (
                                <>
                                  İşletme Referans Kodu{" "}
                                  <span
                                    style={{
                                      color: "#94a3b8",
                                      fontWeight: 400,
                                      fontSize: 11,
                                    }}
                                  >
                                    (opsiyonel)
                                  </span>
                                </>
                              )}
                            </Form.Label>
                            <div className="form-floating shadow-lg rounded-3 position-relative">
                              <Form.Group controlId="validationUsedReferenceCode">
                                <Form.Control
                                  autoComplete="off"
                                  className="form-control border-0 rounded-3 px-4"
                                  type="text"
                                  placeholder={
                                    isSalesRepReference(values.userType, values.source)
                                      ? "Satış temsilcinizin kodunu giriniz"
                                      : "Sizi davet eden işletmenin kodunu giriniz"
                                  }
                                  style={{ textTransform: "uppercase" }}
                                  onChange={handleChange}
                                  onBlur={(e) => {
                                    handleBlur(e);
                                    handleReferenceCodeBlur(
                                      e,
                                      setFieldValue,
                                      isSalesRepReference(
                                        values.userType,
                                        values.source
                                      )
                                    );
                                  }}
                                  name="usedReferenceCode"
                                  value={values.usedReferenceCode}
                                  isInvalid={
                                    !!errors.usedReferenceCode &&
                                    touched.usedReferenceCode &&
                                    !!errors.usedReferenceCode
                                  }
                                />
                                {referenceCodeStatus === "loading" && (
                                  <div
                                    className="spinner-border spinner-border-sm text-primary position-absolute"
                                    style={{
                                      right: "15px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                    }}
                                    role="status"
                                  >
                                    <span className="visually-hidden">
                                      Yükleniyor...
                                    </span>
                                  </div>
                                )}
                                {referenceCodeStatus === "valid" && (
                                  <i
                                    className="fas fa-check-circle position-absolute"
                                    style={{
                                      right: "15px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      fontSize: "1.2rem",
                                      color: "#198754",
                                    }}
                                  ></i>
                                )}
                                {referenceCodeStatus === "invalid" && (
                                  <i
                                    className="fas fa-times-circle position-absolute"
                                    style={{
                                      right: "15px",
                                      top: "50%",
                                      transform: "translateY(-50%)",
                                      fontSize: "1.2rem",
                                      color: "#dc3545",
                                    }}
                                  ></i>
                                )}
                              </Form.Group>
                            </div>
                            <small
                              className="text-muted px-1 d-block mt-1"
                              style={{ fontSize: 10 }}
                            >
                              {isSalesRepReference(values.userType, values.source)
                                ? "Kodu bayi satış temsilcinizden alabilirsiniz."
                                : "Kodu sizi davet eden işletmeden alabilirsiniz."}
                            </small>
                            <span className={style.errorMessage}>
                              {errors.usedReferenceCode &&
                                touched.usedReferenceCode &&
                                errors.usedReferenceCode}
                            </span>
                            {referenceCodeStatus === "valid" && (
                              <span
                                className="small mt-1 d-block px-1"
                                style={{ color: "#198754" }}
                              >
                                <i className="fas fa-user-check me-1"></i>{" "}
                                {referenceCodeMessage}
                              </span>
                            )}
                            {referenceCodeStatus === "invalid" && (
                              <span
                                className="small mt-1 d-block px-1"
                                style={{ color: "#dc3545" }}
                              >
                                <i className="fas fa-exclamation-circle me-1"></i>{" "}
                                {referenceCodeMessage}
                              </span>
                            )}
                          </div>
                        )}
                        <div className="w-100"></div>
                      </>
                    )}

                  <div
                    className="col-xl-8 col-lg-8 col-md-12 col-10 mt-3 mb-2"
                    style={{ paddingLeft: "1.5rem" }}
                  >
                    <Form.Check
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="agreement"
                      checked={values.agreement}
                      style={{ marginBottom: 12 }}
                      label={
                        <span>
                          <span
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                              color: "inherit",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              setShowKisiselVerilerModal(true);
                            }}
                          >
                            Kişisel Veriler Hakkında Bildirim
                          </span>
                          &nbsp;ve&nbsp;
                          <span
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                              color: "inherit",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              setShowAydinlatmaModal(true);
                            }}
                          >
                            Aydınlatma Metni
                          </span>
                          'ni okudum, anladım ve kabul ediyorum.
                          <span style={{ color: "#C62828" }}>*</span>
                        </span>
                      }
                      isInvalid={
                        !!errors.agreement &&
                        touched.agreement &&
                        !!errors.agreement
                      }
                      id="agreement"
                    />
                    <Form.Check
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="marketingConsent"
                      checked={values.marketingConsent}
                      label={
                        <span>
                          Kampanya ve bilgilendirme amaçlı{" "}
                          <span
                            style={{
                              textDecoration: "underline",
                              cursor: "pointer",
                              color: "inherit",
                            }}
                            onClick={(e) => {
                              e.preventDefault();
                              setShowElektronikIletiModal(true);
                            }}
                          >
                            elektronik ileti
                          </span>{" "}
                          almayı kabul ediyorum.{" "}
                          <span style={{ color: "#C62828" }}>*</span>
                        </span>
                      }
                      isInvalid={
                        !!errors.marketingConsent &&
                        touched.marketingConsent &&
                        !!errors.marketingConsent
                      }
                      id="marketingConsent"
                    />
                    <span className={style.errorMessage}>
                      {errors.marketingConsent &&
                        touched.marketingConsent &&
                        errors.marketingConsent}
                    </span>
                  </div>
                  <div className="w-100"></div>

                  <div className="col-xl-6 col-lg-8 col-md-12 col-10">
                    <button
                      type="submit"
                      disabled={isSubmitting}
                      className="btn btn-blue py-sm-3 py-2 px-sm-4 px-3 rounded-3 w-100 mb-3 mt-2"
                    >
                      {isSubmitting ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Üye Olunuyor...
                        </>
                      ) : (
                        <>
                          Üye Ol<i className="fas fa-arrow-right ms-3"></i>
                        </>
                      )}
                    </button>
                    <div className="text-center text-gray small mb-4">
                      <Link to="/login">Giriş Yap</Link> veya{" "}
                      <Link to="/passwordReset">Şifremi Unuttum</Link>
                    </div>
                  </div>
                  <div className="w-100"></div>

                  <div className="col-xl-4 col-lg-6 col-md-8 col-10">
                    {/* <LoginFooter /> */}
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>
        <div className="col-xl-12">
          {/* TODO: Timer Component */}
          <Form
            noValidate
            validated={confirmValidated}
            onSubmit={handleConfirmCode}
            className={sentCode ? "d-flex flex-column" : "d-none"}
          >
            {/* Onay kodunun hangi kanal ile gönderildiği bilgisi */}
            <div className="text-center mb-4">
              <p className="mb-1">
                Onay kodu telefon numaranıza{" "}
                <strong>SMS</strong> ile gönderildi:
              </p>
              <strong style={{ fontSize: "18px" }}>
                {maskPhone(confirmMobileNo)}
              </strong>
            </div>

            {time && !timerExpired && (
              <div className="mb-5 ml-auto mr-auto">
                <Timer expiryTimestamp={time} onExpire={handleExpire} />
              </div>
            )}

            {timerExpired && (
              <p className="text-center text-danger mb-4">
                Süreniz doldu. Lütfen "Tekrar Kod Gönder" butonuna basarak yeni
                kod isteyiniz.
              </p>
            )}

            <Form.Group
              controlId="validationCustom01"
              style={{
                width: "50%",
                marginLeft: "auto",
                marginRight: "auto",
              }}
            >
              <Form.Control
                type="text"
                placeholder="Onay Kodu"
                value={confirmCode}
                onChange={(e) => setConfirmCode(e.target.value)}
                disabled={timerExpired ? true : false}
              />
            </Form.Group>

            <div
              style={{
                width: "50%",
                marginLeft: "auto",
                marginRight: "auto",
                marginTop: "40px",
                display: "flex",
                justifyContent: "center",
              }}
            >
              {timerExpired ? (
                <Button
                  block
                  type="button"
                  onClick={handleResendCode}
                  style={{
                    backgroundColor: "#0d6efd",
                    borderColor: "#0d6efd",
                    color: "#fff",
                  }}
                >
                  Tekrar Kod Gönder
                </Button>
              ) : (
                <Button
                  block
                  type="submit"
                  style={{
                    backgroundColor: "#198754",
                    borderColor: "#198754",
                    color: "#fff",
                  }}
                >
                  Doğrula
                </Button>
              )}
            </div>
          </Form>
        </div>
      </section>

      {/* Aydınlatma Metni Modal - Login sayfasındaki ile aynı */}
      <Modal
        show={showAydinlatmaModal}
        onHide={() => setShowAydinlatmaModal(false)}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Aydınlatma Metni</Modal.Title>
          <button
            type="button"
            className="border-0 bg-transparent"
            onClick={() => setShowAydinlatmaModal(false)}
          >
            <i className="fas fa-times"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            <LegalText type={LEGAL_TEXT_TYPES.AYDINLATMA_METNI} />
          </div>
        </Modal.Body>
      </Modal>

      {/* Elektronik İleti Bilgilendirme Modal */}
      <Modal
        show={showElektronikIletiModal}
        onHide={() => setShowElektronikIletiModal(false)}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Ticari Elektronik İleti İzni</Modal.Title>
          <button
            type="button"
            className="border-0 bg-transparent"
            onClick={() => setShowElektronikIletiModal(false)}
          >
            <i className="fas fa-times"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            <LegalText type={LEGAL_TEXT_TYPES.TICARI_ELEKTRONIK_ILETI_IZNI} />
          </div>
        </Modal.Body>
      </Modal>

      {/* Kişisel Veriler Hakkında Bildirim Modal */}
      <Modal
        show={showKisiselVerilerModal}
        onHide={() => setShowKisiselVerilerModal(false)}
        size="lg"
      >
        <Modal.Header>
          <Modal.Title>Kişisel Veriler Hakkında Bildirim</Modal.Title>
          <button
            type="button"
            className="border-0 bg-transparent"
            onClick={() => setShowKisiselVerilerModal(false)}
          >
            <i className="fas fa-times"></i>
          </button>
        </Modal.Header>
        <Modal.Body>
          <div style={{ maxHeight: "400px", overflowY: "auto" }}>
            <LegalText type={LEGAL_TEXT_TYPES.KISISEL_VERILER_BILDIRIMI} />
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default SingUp;
